import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  DynamicIbanInvoiceAddCommand,
  DynamicIbanInvoiceAddResponseDto,
  DynamicIbanInvoiceApi,
  IbanInvoiceResponseDto,
  IbanQrApi,
} from "api";

import { ApiError } from "types";

const ibanQrApi = new IbanQrApi();
const dynamicIbanQrApi = new DynamicIbanInvoiceApi();

export interface IbanQrState {
  iban: IbanInvoiceResponseDto | null;
}

const initialState: IbanQrState = {
  iban: null,
};

export const createDynamicIbanQr = createAsyncThunk<
  DynamicIbanInvoiceAddResponseDto,
  DynamicIbanInvoiceAddCommand,
  { rejectValue: ApiError }
>("publicIbanQr/createDynamic", async (body, { rejectWithValue }) => {
  try {
    const { data } =
      await dynamicIbanQrApi.apiDynamicInvoiceNewQrInvoicePost(body);
    return data;
  } catch (error) {
    const { response } = error as { response: ApiError };
    return rejectWithValue(response);
  }
});

export const getIbanQr = createAsyncThunk<
  IbanInvoiceResponseDto,
  {
    uid: string;
    onSuccess?: (data: IbanInvoiceResponseDto) => void;
    onError?: (message: string) => void;
  },
  { rejectValue: ApiError }
>(
  "publicIbanQr/getByUid",
  async ({ uid, onSuccess, onError }, { rejectWithValue }) => {
    try {
      const { data } = await ibanQrApi.apiIbanQrIbanInvoiceUidGet(uid);

      if (onSuccess) {
        onSuccess(data);
      }

      return data;
    } catch (error) {
      const { response } = error as { response: ApiError };

      if (onError) {
        onError(response.data.title);
      }

      return rejectWithValue(response);
    }
  },
);

const ibanSlice = createSlice({
  name: "publicIbanQr",
  initialState,
  reducers: {},
});

export default ibanSlice.reducer;
